import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import MainContentLayout from '../../../components/Layout/MainContentLayout';
import BannerList from './BannerList';
import { useLocation, useParams } from 'react-router-dom';
import ViewBannerDetails from './ViewBannerDetails';
import AddEditBanner from './AddEditBanner';

const Banners = () => {
    const menuDispatch = useDispatch();
    const {id} = useParams();
    const path = useLocation().pathname;
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'banners'
        });
    }, []);
    return (
        <>
            {path === "/marketing/banners" && <BannerList />}
            
            {path.startsWith("/marketing/banner/") &&
                !path.startsWith("/marketing/banner/view/") &&
                id && <AddEditBanner />}

            {path.startsWith("/marketing/banner/view/") && id > 0 && <ViewBannerDetails />}
        </>
    )
}

export default Banners;
